// Espace de l'agent (M11) : ses demandes de congé et ses évaluations validées, pour le compte lié à une
// fiche d'agent ; aucune autre permission n'est requise. Sans fiche liée, un état vide l'explique.
import { LIBELLES_ETAT_CONGE, LIBELLES_TYPE_CONGE, type CongeVueValidation } from '@cc/contrats';
import { EtatVide, LienBouton, Panneau, PuceEtat, Tableau, type ColonneTableau } from '@cc/ui';
import { ArrowLeft, UserRound } from 'lucide-react';
import { EnTetePage } from '../../commun/EnTetePage';
import { EtatRequete } from '../../commun/EtatRequete';
import { date } from '../../commun/format';
import { useMesConges, useMesEvaluations } from './api';
import { jours, periode, TON_CONGE } from './logique';
import commun from '../../commun/commun.module.css';

const colonnes: ColonneTableau<CongeVueValidation>[] = [
  { id: 'type', entete: 'Type', enTeteLigne: true, cellule: (c) => LIBELLES_TYPE_CONGE[c.type] },
  { id: 'periode', entete: 'Période', cellule: (c) => periode(c), valeurTri: (c) => c.debut },
  { id: 'jours', entete: 'Durée', numerique: true, cellule: (c) => jours(c.demi_journees) },
  { id: 'etat', entete: 'État', cellule: (c) => <PuceEtat ton={TON_CONGE[c.etat]} libelle={LIBELLES_ETAT_CONGE[c.etat]} /> },
];

export function PageMonEspace() {
  const conges = useMesConges();
  const evaluations = useMesEvaluations();
  const nonLie = conges.data?.agent === false;
  return (
    <>
      <EnTetePage etiquette="Personnel" titre="Mon espace" description="Vos demandes de congé et vos évaluations validées."
        actions={<LienBouton href="/personnel" icone={ArrowLeft} variante="secondaire">Personnel</LienBouton>} />
      <EtatRequete chargement={conges.isPending || evaluations.isPending} erreur={conges.error ?? evaluations.error} onReessayer={() => { void conges.refetch(); void evaluations.refetch(); }} lot="L5-A" fonction="Votre espace">
        {nonLie ? (
          <EtatVide titre="Aucune fiche d'agent liée à votre compte" icone={UserRound}><p>Votre compte de connexion n&apos;est rattaché à aucune fiche du personnel de cette collectivité. Les ressources humaines peuvent établir ce lien.</p></EtatVide>
        ) : (
          <div className={commun.pile}>
            <Panneau titre="Mes demandes de congé" niveau={2}>
              {(conges.data?.elements ?? []).length ? <Tableau legende="Mes demandes de congé" colonnes={colonnes} lignes={conges.data?.elements ?? []} cleLigne={(c) => c.id} /> : <p>Aucune demande enregistrée.</p>}
            </Panneau>
            <Panneau titre="Mes évaluations validées" niveau={2}>
              {(evaluations.data?.elements ?? []).length === 0 ? <p>Aucune évaluation validée.</p> : (evaluations.data?.elements ?? []).map((e) => (
                <Panneau key={e.id} interne titre={`${e.campagne} (${e.annee})`} niveau={3}>
                  <dl className={commun.definitions}>
                    {e.grille.map((c) => <div key={c.code}><dt>{c.libelle}</dt><dd>{e.notes[c.code] !== undefined ? `${e.notes[c.code]} sur ${c.maximum}` : 'non notée'}</dd></div>)}
                    <dt>Commentaire</dt><dd>{e.commentaire || 'aucun'}</dd>
                    <dt>Validée le</dt><dd>{date(e.validee_le)}</dd>
                  </dl>
                </Panneau>
              ))}
            </Panneau>
          </div>
        )}
      </EtatRequete>
    </>
  );
}
